import { render } from "./Dropdown.vue?vue&type=template&id=512c4814&scoped=true"
import script from "./Dropdown.vue?vue&type=script&lang=ts"
export * from "./Dropdown.vue?vue&type=script&lang=ts"

import "./Dropdown.vue?vue&type=style&index=0&id=512c4814&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-512c4814"

export default script